import {Entity} from "../Entity";

export class ErrorLog implements Entity {
    id: string;
    occurred: Date;

    constructor(id: string, occured: string | Date) {
        this.id = id;
        this.occurred = new Date(occured);
    }

    public get occurredAsString(): string {
        return this.occurred.toLocaleString();
    }
}
